/* global mixpanel */

export function ingredientRecipesStart ({outletIds}) {
  mixpanel.track('Ingredient Recipes Start', {
    'Current Selected Outlet': outletIds
  })
}

export function ingredientRecipesChangeFilter ({outletIds}) {
  mixpanel.track('Ingredient Recipes Change Outlet', {
    'Current Selected Outlet': outletIds
  })
}

export function ingredientRecipesSelect ({recipe}) {
  mixpanel.track('Ingredient Recipes Select', {
    'Item Name': recipe.item_name,
    'Item Variant Name': recipe.item_variant_name,
    'Ingredient': recipe.recipe_ingredients.map((ri) => ({
      'Ingredient Name': ri.ingredient_name,
      'Ingredient Quantity': ri.quantity,
      'Ingredient Unit': ri.unit_name
    }))
  })
}

export function ingredientRecipesCreate ({recipe, allOutlet}) {
  let eventName
  if (allOutlet) {
    eventName = 'Ingredient Recipes Create All Outlet'
  } else {
    eventName = 'Ingredient Recipes Create One Outlet'
  }
  mixpanel.track(eventName, {
    'Item Name': recipe.item_name,
    'Item Variant Name': recipe.item_variant_name,
    'Ingredient': recipe.recipe_ingredients.map((ri) => ({
      'Ingredient Name': ri.ingredient_name,
      'Ingredient Quantity': ri.quantity,
      'Ingredient Unit': ri.unit_name
    }))
  })
}

export function ingredientRecipesUpdate ({recipe}) {
  mixpanel.track('Ingredient Recipes Update One Outlet', {
    'Item Name': recipe.item_name,
    'Item Variant Name': recipe.item_variant_name,
    'Ingredient': recipe.recipe_ingredients.map((ri) => ({
      'Current Ingredient Name': ri.ingredient_name,
      'Current Ingredient Quantity': ri.quantity,
      'Current Ingredient Unit': ri.unit_name
    }))
  })
}

export function ingredientRecipesDelete ({recipe}) {
  mixpanel.track('Ingredient Recipes Delete One Outlet', {
    'Item Name': recipe.item_name,
    'Item Variant Name': recipe.item_variant_name,
    'Ingredient': recipe.recipe_ingredients.map((ri) => ({
      'Ingredient Name': ri.ingredient_name,
      'Ingredient Quantity': ri.quantity,
      'Ingredient Unit': ri.unit_name
    }))
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/ingredient/recipes.js